
export const projectExpandedMenuWidth = 270;
export const projectCollapsedMenuWidth = 55;